import template from './terms-list.html';

export default {
  template,
  bindings: {
    list: '<',
    buttonAction: '&',
  }
}



// WEBPACK FOOTER //
// ./src/modules/terms-preview/components/terms-list/terms-list-component.js